import * as React from 'react';
import {BillToAccountDetails} from "./PaymentMethod";
import NewCard, {CardDetails} from "./NewCard";
import NewBankAccount, {BankAccountDetails} from "./NewBankAccount";
import BillToAccount, {BTADetails} from "./BillToAccount";
import {RulesMessages} from "../utils/validator";
import Popup from "./Popup";

export interface PaymentMethodValueType {
  paymentType: string;
  billToAccountDetails?: BillToAccountDetails;
  cardDetails?: CardDetails;
  bankDetails?: BankAccountDetails;
}

interface PaymentOptionPopupProps {
  accountNumber?: string;
  emailAddress?: string;
  ebillEnrolled?: boolean;
  paymentType: string;
  hideSavePaymentInfo: boolean;
  onOk: (details: PaymentMethodValueType) => void;
  onClose: () => void;
  cardRulesMessages?: { [key: string]: RulesMessages };
  eftRulesMessages?: { [key: string]: RulesMessages };
  toolTip?: React.ReactNode;
}

export default function PaymentOptionPopup(props: PaymentOptionPopupProps) {
  let paymentOption = <></>;
  if (props.paymentType === 'NEWCARD') {
    paymentOption = (
        <NewCard
            rulesMessages={props.cardRulesMessages}
            displayDetails
            onAddCard={(newCardDetails: CardDetails) => {
              props.onOk({
                cardDetails: newCardDetails,
                paymentType: 'CARD'
              });
            }}
            hideSavePaymentInfo={props.hideSavePaymentInfo}
            toolTip={props.toolTip}
        />
    );
  } else if (props.paymentType === 'NEWEFT') {
    paymentOption = (
        <NewBankAccount
            rulesMessages={props.eftRulesMessages}
            displayDetails
            onAddBank={(newBankDetails: BankAccountDetails) => {
              props.onOk({
                bankDetails: newBankDetails,
                paymentType: 'EFT'
              });
            }}
            hideSavePaymentInfo={props.hideSavePaymentInfo}
        />
    );
  } else if (props.paymentType === 'BILLTOACCOUNT') {
    paymentOption = (
        <BillToAccount
            displayDetails
            accountNumber={props.accountNumber}
            emailAddress={props.emailAddress}
            eBillEnrolled={props.ebillEnrolled}
            onAddBTA={(details: BTADetails) => {
              props.onOk({
                billToAccountDetails: details,
                paymentType: 'BILLTOACCOUNT'
              });
            }}
        />
    );
  }

  return (
      <Popup
          modal
          displayCloseButton
          position="relative"
          className="addPaymentPopup"
          onClose={props.onClose}
      >
        {paymentOption}
      </Popup>
  );
}
